import { CircularProgress, LinearProgress } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { IKakarikoProgressStyleProps } from './types';

export const StyledCircularProgress = styled(
  CircularProgress,
)<IKakarikoProgressStyleProps>`
  ${(props: IKakarikoProgressStyleProps) => {
    const { $color = 'primary', size = 24 } = props;

    return css`
      position: absolute;
      top: calc(50% - ${size * 0.5}px);
      left: calc(50% - ${size * 0.5}px);

      &.MuiCircularProgress-colorPrimary {
        color: var(--${$color}-base);
      }
    `;
  }}
`;

export const StyledLinearProgress = styled(
  LinearProgress,
)<IKakarikoProgressStyleProps>`
  ${(props: IKakarikoProgressStyleProps) => {
    const { $color = 'primary', size = 24 } = props;

    return css`
      position: absolute;
      top: calc(50% - ${size * 0.5}px);
      left: calc(50% - ${size * 0.5}px);

      &.MuiLinearProgress-colorPrimary {
        background-color: var(--${$color}-light);
      }

      .MuiLinearProgress-barColorPrimary {
        background-color: var(--${$color}-dark);
      }
    `;
  }}
`;
